/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AnswersControllerFindOneQueryResponse, AnswersControllerFindOnePathParams, AnswersControllerFindOneQueryParams, AnswersControllerFindOne400, AnswersControllerFindOne401, AnswersControllerFindOne403, AnswersControllerFindOne404 } from "../../models/checklistsController/AnswersControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { answersControllerFindOne } from "../../clients/checklistsService/answersControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const answersControllerFindOneQueryKey = (id: AnswersControllerFindOnePathParams["id"], params: AnswersControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-answers/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type AnswersControllerFindOneQueryKey = ReturnType<typeof answersControllerFindOneQueryKey>;
export function answersControllerFindOneQueryOptions(id: AnswersControllerFindOnePathParams["id"], params?: AnswersControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = answersControllerFindOneQueryKey(id, params);
  return queryOptions<AnswersControllerFindOneQueryResponse, ResponseErrorConfig<AnswersControllerFindOne400 | AnswersControllerFindOne401 | AnswersControllerFindOne403 | AnswersControllerFindOne404>, AnswersControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return answersControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist answer by ID
 * {@link /api/v1/checklist-answers/:id}
 */
export function useAnswersControllerFindOne<TData = AnswersControllerFindOneQueryResponse, TQueryData = AnswersControllerFindOneQueryResponse, TQueryKey extends QueryKey = AnswersControllerFindOneQueryKey>(id: AnswersControllerFindOnePathParams["id"], params?: AnswersControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<AnswersControllerFindOneQueryResponse, ResponseErrorConfig<AnswersControllerFindOne400 | AnswersControllerFindOne401 | AnswersControllerFindOne403 | AnswersControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? answersControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...answersControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AnswersControllerFindOne400 | AnswersControllerFindOne401 | AnswersControllerFindOne403 | AnswersControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}